import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import useFirebaseCart from './useFirebaseCart';
import { useAddress } from '../context/AddressContext';
import '../styles/tkwaycart.css';
export default function Tkwaycart() {
  const { storeId, tableNo } = useParams();
  const navigate = useNavigate();
  const { language } = useLanguage();
  const [showCommentInput, setShowCommentInput] = useState(false);
  const [comment, setComment] = useState('');
  const [tempComment, setTempComment] = useState('');
  const { addressData } = useAddress();
  const hasAddress = !!(addressData?.phone && addressData?.name && addressData?.address);
  const [confirmSuccess, setConfirmSuccess] = useState(false);
  const orderConfirmed = confirmSuccess;
  useEffect(() => { if (!hasAddress) navigate(`/order/${storeId}/${tableNo}`); }, [hasAddress, navigate, storeId, tableNo]);
  const { cartItems, confirmedOrders, cartTotal, confirmedTotal, isProcessing, error,
    loadCart, fetchOrders, changeQty, removeItem, confirmOrder: checkout } = useFirebaseCart(storeId, tableNo, hasAddress);
  const refresh = () => { loadCart(); fetchOrders().catch(() => {}); };
  const customerInfo = confirmedOrders[0] || null;
  const handleAddComment = () => {
    setTempComment(comment);
    setShowCommentInput(true);
  };

 
  const handleOkComment = () => {
    setComment(tempComment);
    setShowCommentInput(false);
  };

 
  const handleCancelComment = () => {
    setTempComment(comment);
    setShowCommentInput(false);
  };
 
  const handleCommentChange = (e) => {
    setTempComment(e.target.value);
  };

  async function confirmOrder() {
    const success = await checkout(comment, { usrname: addressData.name, phone: addressData.phone, address: addressData.address });
    if (success) {
      setComment(''); setShowCommentInput(false);
      setConfirmSuccess(true);
    }
  }
  if (confirmSuccess) {
    return (
      <div className="cart-page">
      {error && <p role="alert">{error}</p>}
        <div className="success-screen">
          <div className="success-icon">✓</div>
          <h2 className="success-title">
            {language === "cn" ? "Success" : "成功"}
          </h2>
          <p className="success-message">
            {language === "cn" 
              ? "Your order has been initiated successfully, you will get a call for confirmation." 
              : "订单生成成功，请耐心等待确认电话。"}
          </p>
          <div className="bottom-half">
          {confirmedOrders.length ? (
            <>
              {confirmedOrders.map(item => (
                <div key={item._id} className="order-item">
                  <span className="name">{language === "cn" ? item.itemnamecn : item.itemname}</span>
                  <span className="qty">x{item.quantity}</span>
                  <span className="price">Rs. {item.price}</span>
                  
                  {item.comment && (
                    <div className="item-comment">
                      📝 {item.comment}
                    </div>
                  )}
                </div>
              ))}

              <div className="order-total">
                <span className="order-total-label">{language === "cn" ? "Total:" : "合计"}</span>
                <span className="order-total-amount">
                  Rs. {confirmedTotal}
                </span>
              </div>

    
              {customerInfo && (customerInfo.usrname || customerInfo.phone || customerInfo.address) && (
                <div className="customer-info-section">
                  <h4 className="customer-info-title">
                    {language === "cn" ? "Customer Information" : "客户信息"}
                  </h4>
                  <div className="customer-info-details">
                    {customerInfo.usrname && (
                      <div className="info-row">
                        <span className="info-label">{language === "cn" ? "Name:" : "姓名:"}</span>
                        <span className="info-value">{customerInfo.usrname}</span>
                      </div>
                    )}
                    {customerInfo.phone && (
                      <div className="info-row">
                        <span className="info-label">{language === "cn" ? "Phone:" : "电话:"}</span>
                        <span className="info-value">{customerInfo.phone}</span>
                      </div>
                    )}
                    {customerInfo.address && (
                      <div className="info-row address-row">
                        <span className="info-label">{language === "cn" ? "Address:" : "地址:"}</span>
                        <span className="info-value">{customerInfo.address}</span>
                      </div>
                    )}
      
                    {customerInfo.comment && (
                      <div className="info-row comment-row">
                        <span className="info-label">{language === "cn" ? "Comment:" : "评论:"}</span>
                        <span className="info-value comment-value">📝 {customerInfo.comment}</span>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className="empty">{language === "cn" ? "No confirmed items" : "没有订单"}</div>
          )}</div>
          <button 
            className="continue-shopping-btn"
            onClick={() => navigate(`/order/${storeId}/${tableNo}`)}
          >
            {language === "cn" ? "Continue Shopping" : "继续购物"}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      {error && <p role="alert">{error}</p>}
   
      {!orderConfirmed && (
        <div className="top-half">
          <div className="title-container">
            <div className="title-spacer" />
            <h2 className="title-bold">{language === "cn" ? "My Cart" : "我的购物车"}</h2>
            <button 
              className="refresh-btn" 
              onClick={refresh}
              disabled={isProcessing}
            >
              ⟳
            </button>
          </div>
          {cartItems.map(item => (
            <div key={item._id} className="cart-item">
              <div className="item-name">
                {language === "cn" ? item.itemnamecn : item.itemname}
              </div>

              <div className="qty-group">
                <button
                  className="minus"
                  onClick={() => changeQty(item._id, -1)}
                  disabled={isProcessing}
                >
                  −
                </button>

                <span className="quantity">{item.quantity}</span>

                <button
                  className="plus"
                  onClick={() => changeQty(item._id, 1)}
                  disabled={isProcessing}
                >
                  +
                </button>
              </div>

              <div className="price">
                Rs. {item.price}
              </div>

              <button
                className="delete"
                onClick={() => removeItem(item._id)}
                disabled={isProcessing}
              >
                {language === "cn" ? "Remove" : "删除"}
              </button>
            </div>
          ))}
        </div>
      )}
      {!orderConfirmed && (
        <div className="bottom-bar">
          <span className="total">{language === "cn" ? "Total:" : "合计"} Rs. {cartTotal}</span>
          
      
          <button
            className="add-comment-btn"
            onClick={handleAddComment}
            disabled={showCommentInput || isProcessing}
          >
            {language === "cn" ? "Add Comment" : "添加评论"}
          </button>
          
          <button
            className="confirm"
            disabled={!cartItems.length || isProcessing}
            onClick={confirmOrder}
          >
            <div className="empty">{language === "cn" ? "Confirm" : "确认"}</div>
          </button>
        </div>
      )}

     
      {showCommentInput && (
        <div className="comment-modal">
          <div className="comment-modal-content">
            <textarea
              className="comment-input"
              value={tempComment}
              onChange={handleCommentChange}
              placeholder={language === "cn" ? "Enter your comment..." : "输入评论..."}
              rows="3"
            />
            <div className="comment-modal-buttons">
              <button className="comment-ok-btn" onClick={handleOkComment}>
                {language === "cn" ? "OK" : "确定"}
              </button>
              <button className="comment-cancel-btn" onClick={handleCancelComment}>
                {language === "cn" ? "Cancel" : "取消"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}